import React, { useEffect, useState } from 'react';

import { LayerDataBridge } from './layer-data-bridge';

interface BridgeFocusLayerContentProps<T> {
  bridge: LayerDataBridge<T>;
  renderView: (data: T) => React.ReactNode;
}

const BridgeFocusLayerContent = <T,>({
  bridge,
  renderView,
}: BridgeFocusLayerContentProps<T>) => {
  const [data, setData] = useState<T | null>(bridge.getData());

  useEffect(() => {
    return bridge.subscribe(setData);
  }, [bridge]);

  if (!data) return null;

  return <>{renderView(data)}</>;
};

export const createBridgeFocusLayerRender = <T,>(
  renderView: (data: T) => React.ReactNode,
) => (
  state: { dataBridge: LayerDataBridge<T> },
  _close: any,
): JSX.Element => (
  <BridgeFocusLayerContent bridge={state.dataBridge} renderView={renderView} />
);
